// True while react-snap prerenders the app at build time — it drives headless
// Chrome with this exact user-agent. Lets the app skip runtime-only side
// effects (reCAPTCHA, analytics) that would error or be pointless at build time.
export const isPrerender = (): boolean =>
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
